import { Modal } from 'antd'

const PRE_BLOCK_STYLE = {
	whiteSpace: 'pre-wrap',
	wordBreak: 'break-word',
	background: '#fafafa',
	padding: 12,
	borderRadius: 6,
	border: '1px solid #f0f0f0',
	maxHeight: 360,
	overflow: 'auto',
}

/**
 * Ant Design v4: uses `visible` (not `open`).
 * Shared prompt preview for dictionary AI flows and agent admin screens.
 */
export const AIPromptPreviewModal = ({
	visible,
	title = 'AI Prompt Preview',
	width = 760,
	onCancel,
	prompt = '',
	model = '',
	temperature = 0,
	maxOutputTokens = 0,
	/** When true, show "(default)" instead of 0 for max output tokens (agent admin previews). */
	maskZeroMaxOutputTokens = false,
	preStyle = {},
}) => {
	const maxOutDisplay =
		maskZeroMaxOutputTokens && !maxOutputTokens
			? '(default)'
			: maxOutputTokens

	return (
		<Modal
			visible={visible}
			title={title}
			onCancel={onCancel}
			footer={null}
			width={width}
		>
			<div style={{ marginBottom: 8 }}>
				<strong>Model:</strong> {model || '-'} {' | '}
				<strong>Temperature:</strong> {temperature} {' | '}
				<strong>Max output tokens:</strong> {maxOutDisplay}
			</div>
			<pre style={{ ...PRE_BLOCK_STYLE, ...preStyle }}>
				{prompt || '(empty prompt)'}
			</pre>
		</Modal>
	)
}
